import { serviceApi } from 'Shared/network';
import type {
  GetPointTrendOkDto,
  PointControllerGetPointTrendPointCategoriesEnum,
} from 'viewup-api';

const pointCategories: PointControllerGetPointTrendPointCategoriesEnum[] = [
  'click',
  'auto',
  'plus',
  'post',
  'etc',
];

export interface GetTrendReq {
  monthValue?: number;
  type: 'day' | 'year';
  yearValue: number;
}

export const getTrend = async ({
  monthValue,
  type,
  yearValue,
}: GetTrendReq): Promise<GetPointTrendOkDto> => {
  const response = await serviceApi.v1Point.pointControllerGetPointTrend({
    month: type === 'day' ? monthValue : undefined,
    pointCategories,
    year: yearValue,
  });

  return response.data;
};
